import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { OperatorApp } from "./OperatorApp";
import "./styles.css";
import "./participant.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {window.location.pathname === "/operator" || window.location.pathname.startsWith("/operator/")
      ? <OperatorApp />
      : <App />}
  </StrictMode>,
);
